import { captureAnalytics } from "../analytics";
import { isAssistantClientError, type AssistantClientFailureReason, type AssistantClientFailureStage } from "./client-error";

export type AssistantClientFailureEvent = {
  action: "quote" | "send";
  stage: AssistantClientFailureStage;
  reason: AssistantClientFailureReason | "unknown";
  status: number | null;
  request_id: string | null;
  attempts: number;
};
const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[1-8][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;
const REASONS = new Set<string>(["auth_timeout", "auth", "network", "http", "invalid_response", "interrupted_stream", "protocol", "timeout"]);
const STAGES = new Set<string>(["authentication", "request", "response", "stream"]);

/** One event per terminal operation, never per recovery poll. Explicitly
 * construct its fields so submitted data and raw errors cannot be captured. */
export function reportAssistantClientFailure(action: "quote" | "send", requestId: string, attempts: number, failure: unknown, status?: number): void {
  try {
    const client = isAssistantClientError(failure) ? failure : null;
    const httpStatus = client?.status ?? status;
    captureAnalytics("assistant_client_request_failed", {
      action,
      stage: client && STAGES.has(client.stage) ? client.stage : "request",
      reason: client && REASONS.has(client.reason) ? client.reason : "unknown",
      status: typeof httpStatus === "number" && Number.isInteger(httpStatus) && httpStatus >= 100 && httpStatus <= 599 ? httpStatus : null,
      request_id: UUID.test(requestId) ? requestId : null,
      attempts: Number.isInteger(attempts) ? Math.max(0, Math.min(6, attempts)) : 0,
    });
  } catch { /* Diagnostics must never change recovery or billing behavior. */ }
}
